import axios, { AxiosInstance } from "axios";
import { config } from "../config/app-config";

//NOSONAR
type ConnectionName = string;

const HttpsConnections: Record<ConnectionName, AxiosInstance> = {};

// Configure axios defaults from unified config. qubes is deprecated + optional;
// only set the default base URL when this deployment actually has qubes.
if (config.qubes?.publicUrl) {
  axios.defaults.baseURL = config.qubes.publicUrl;
}

const HttpsService = {
  getHttps() {
    let httpsInstance: AxiosInstance = HttpsConnections["qubes"];
    if (!httpsInstance) {
      httpsInstance = axios.create({
        withCredentials: true, // Enable sending cookies cross-domain
      });

      //could possibly detect expired tokens here and either refresh the token/force login
      // probably need to update the userSlice to remove the user

      httpsInstance.interceptors.request.use((config) => {
        const params = config?.params ?? {};

        if (typeof params["_ts"] === "undefined") {
          params["_ts"] = String(new Date().getTime());
          config.params = params;
        }
        return config;
      });

      HttpsConnections["qubes"] = httpsInstance;
    }

    return httpsInstance;
  },
};

export default HttpsService;
